/** Scheduled-outage display helpers. Every time the page shows is Australia/Sydney, whatever the browser's zone. */

export const OUTAGE_ZONE = "Australia/Sydney";
export const MIN_DURATION_MINUTES = 15;
export const MAX_DURATION_MINUTES = 720;

const partsFmt = new Intl.DateTimeFormat("en-AU", {
  timeZone: OUTAGE_ZONE,
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
  hourCycle: "h23",
  timeZoneName: "shortOffset",
});

function parts(instant: Date): Record<string, string> {
  const out: Record<string, string> = {};
  for (const p of partsFmt.formatToParts(instant)) out[p.type] = p.value;
  return out;
}

/** "2027-06-04 12:00 Sydney (GMT+10)" for an ISO instant. */
export function formatSydney(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  const p = parts(d);
  return `${p.year}-${p.month}-${p.day} ${p.hour}:${p.minute} Sydney (${p.timeZoneName})`;
}

/** The Sydney calendar date (yyyy-mm-dd) of an ISO instant. */
export function sydneyDate(iso: string | Date): string {
  const d = typeof iso === "string" ? new Date(iso) : iso;
  const p = parts(d);
  return `${p.year}-${p.month}-${p.day}`;
}

/** The slot the server will assign. Display only: the server applies the rule and the page never sends a start. */
export function slotHour(durationMinutes: number): 12 | 19 {
  return durationMinutes <= 90 ? 12 : 19;
}

export function slotLabel(durationMinutes: number): string {
  return `${String(slotHour(durationMinutes)).padStart(2, "0")}:00 Sydney time`;
}

/** Returns an error message, or null when the date and duration may be submitted. */
export function validateWhen(date: string, durationText: string): string | null {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(date)) return "Choose a date.";
  if (date < sydneyDate(new Date())) return "The date is in the past (Sydney date).";
  if (!/^\d+$/.test(durationText.trim())) {
    return `Duration must be a whole number of minutes, ${MIN_DURATION_MINUTES} to ${MAX_DURATION_MINUTES}.`;
  }
  const n = Number(durationText);
  if (n < MIN_DURATION_MINUTES || n > MAX_DURATION_MINUTES) {
    return `Duration must be ${MIN_DURATION_MINUTES} to ${MAX_DURATION_MINUTES} minutes.`;
  }
  return null;
}

export const STATE_LABEL: Record<string, string> = {
  scheduled: "Scheduled",
  in_progress: "In progress",
  restored: "Restored",
  cancelled: "Cancelled",
};
